import React, { FC } from 'react'
import { ASSETS } from '../../../constants/assets'
import { ModuleNames } from '../../../constants/componentNames.constants'
import { URLS } from '../../../constants/environment.constants'
import { MenuGroup } from '../../../models/others/menuGroup'
import { TopicCTA } from '../../../models/topics/cta'
import { TopicInternalLink } from '../../../models/topics/internalLink'
import ImgUtil from '../../../utils/img.utils'
import Typography from '../typography'
import WrapperImage from '../wrapperImage'
import { NavLinks, ResponsiveIcon, SubLinks } from './style'

type LandingPageLinkProps = {
  landingPageLink: TopicCTA | TopicInternalLink | {}
}
type HomeLinkProps = {
  homeLink: TopicCTA | TopicInternalLink | {}
}

type NavLogoProps = {
  imgSrc: string
  imgUrl: string
  altText: string
}

type NavIconProps = {
  openMenu: boolean
  setOpenMenu: (prop: boolean) => void
}

type NavItemProps = {
  url: string
  text: string
  className: string
}

type NavLinkProps = {
  navLinks: (MenuGroup | TopicCTA | TopicInternalLink)[]
  openMenu: boolean
}

type NavSublinkProps = {
  newGroupName: string
  subLinks: MenuGroup[]
}

const handleAccordionOpen = (event: any) => {
  const current = event.currentTarget
  const parent = event.currentTarget.parentElement

  if (current.classList.contains('is-active')) {
    current.classList.remove('is-active')
    parent.classList.remove('CustomHeader__Dropdown')
  } else {
    current.classList.add('is-active')
    parent.classList.add('CustomHeader__Dropdown')
  }
}

export const NavLogo: FC<NavLogoProps> = ({ imgSrc, imgUrl, altText }) => (
  <a href={imgSrc} className="logoHref">
    <WrapperImage
      className="CustomHeader__Logo"
      src={ImgUtil.getResizedImageUrl(imgUrl, '')}
      width={136}
      alt={altText}
    />
  </a>
)

export const NavIcon: FC<NavIconProps> = ({ openMenu, setOpenMenu }) => (
  <ResponsiveIcon $openMenu={openMenu} onClick={() => setOpenMenu(!openMenu)}>
    <Typography type="captionAlt" className="CustomHeader__Close"></Typography>

    <div className="CustomHeader__Hamburger">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </ResponsiveIcon>
)

export const LinkItem: FC<NavItemProps> = ({ url, text, className }) => (
  <li className={className}>
    <a href={url}>
      <Typography type={'label'}>{text}</Typography>
    </a>
  </li>
)

export const NavSubLinksMenu: FC<NavSublinkProps> = ({ newGroupName, subLinks }) => (
  <div>
    <button
      className="CustomHeader__Mobile_Button Menu-item js-Menu-item"
      onClick={handleAccordionOpen}>
      <Typography type={'label'}>{newGroupName}</Typography>
    </button>

    <SubLinks className="CustomHeader__Sublinks">
      {subLinks.map((subLink: any) => (
        <LinkItem
          key={subLink?.id}
          url={subLink?.externalUrl}
          text={subLink?.text}
          className={'CustomHeader__Sublink'}
        />
      ))}
    </SubLinks>
  </div>
)

export const LandingPageLink: FC<LandingPageLinkProps> = ({ landingPageLink }) => {
  const externalUrl = 'externalUrl' in landingPageLink ? landingPageLink.externalUrl : undefined
  const text = 'text' in landingPageLink ? landingPageLink.text : ''

  if (!text) return null

  return (
    <div className="countryText">
      <a href={externalUrl}>{text}</a>
    </div>
  )
}

export const HomeLink: FC<HomeLinkProps> = ({ homeLink }) => {
  const externalUrl = 'externalUrl' in homeLink ? homeLink.externalUrl : undefined
  const text = 'text' in homeLink ? homeLink.text : ''

  if (!externalUrl) return null

  return (
    <div className="homeLink">
      <a href={externalUrl}>
        <img src={ASSETS.HOME_ICON_LOGO} />
        {text}
      </a>
    </div>
  )
}

export const NavLinksMenu: FC<NavLinkProps> = ({ navLinks, openMenu }) => (
  <NavLinks $openMenu={openMenu}>
    {navLinks?.map((navLink: any) => {
      const { ctaText, text, internalLink, newGroupName, parentLink, externalUrl } = navLink
      const internalLinkName = ctaText || internalLink?.pageName || internalLink?.name
      const isListMenu = navLink?.groupStyle === 'List'

      const parentLinkSlugUrl =
        parentLink?.internalLink?.slug && URLS.PROD + parentLink.internalLink.slug
      const menuGroupSrc = parentLink?.externalUrl || parentLinkSlugUrl || '#'
      const internalLinkSrc = internalLink?.slug && URLS.PROD + internalLink.slug
      const topicCtaSrc = externalUrl || internalLinkSrc || '#'

      switch (navLink.__typename) {
        case ModuleNames.TOPIC_CTA:
          return (
            <LinkItem
              key={navLink?.id}
              url={topicCtaSrc}
              text={text}
              className={'CustomHeader__NavLink'}
            />
          )

        case ModuleNames.TOPIC_INTERNAL_LINK:
          return (
            <LinkItem
              key={navLink?.id}
              url={internalLinkSrc}
              text={internalLinkName}
              className={'CustomHeader__NavLink'}
            />
          )

        case ModuleNames.MENU_GROUP:
          return (
            <div className="CustomHeader__MenuGroup" key={navLink?.id}>
              <li className={`CustomHeader__NavLink ${isListMenu ? 'NavLink_List' : ''}`}>
                <a href={menuGroupSrc}>
                  <Typography type={'label'}>{newGroupName}</Typography>
                </a>
              </li>

              {isListMenu && (
                <NavSubLinksMenu newGroupName={newGroupName} subLinks={navLink?.pages} />
              )}
            </div>
          )
        default:
          return null
      }
    })}
  </NavLinks>
)
